import axios from 'axios';

const apiData = async (endpoint, params = {}) => {
  let accessToken;

  if (typeof window !== 'undefined') {
    accessToken = window.localStorage.getItem('w4w_token');
  }

  const response = await axios({
    method: 'get',
    baseURL: `${process.env.W4W_API}/api`,
    url: endpoint,
    params,
    ...(accessToken ? { headers: { 'x-access-token': accessToken } } : {}),
  });

  try {
    const data = await response.data;

    return data;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err.response ? err.response.status : err);
  }
};

export default apiData;
